import { render, staticRenderFns } from "./CapacityDashboard.vue?vue&type=template&id=452e8dd4&scoped=true"
import script from "./CapacityDashboard.vue?vue&type=script&lang=js"
export * from "./CapacityDashboard.vue?vue&type=script&lang=js"
import style0 from "./CapacityDashboard.vue?vue&type=style&index=0&id=452e8dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e8dd4",
  null
  
)

export default component.exports